import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import OvTextField from '../atoms/OvTextField';
import OvVideoPlacementPicker from './OvVideoPlacementPicker';
import OvVideoHealthGoalsField from './OvVideoHealthGoalsField';
import { NO_PLACEMENT } from '../../../common/model/dto/video/video-constants';
import { VideoPlacementValues } from '../../../common/model/type/video-placement.types';

interface OvVideoPlacementFieldsProps {
  id: string;
  values: VideoPlacementValues;
  positionError: string | null;
  isDisabled?: boolean;
  isPositionFocused?: boolean;
  onChange: (changes: Partial<VideoPlacementValues>) => void;
}

const OvVideoPlacementFields: FC<OvVideoPlacementFieldsProps> = ({
  id,
  values,
  positionError,
  isDisabled = false,
  isPositionFocused = false,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <Fields>
      <OvVideoPlacementPicker
        id={`${id}-placement`}
        label={t('videos.fields.shownIn')}
        value={values.placement_key}
        isDisabled={isDisabled}
        onChange={(placement_key) => onChange({ placement_key })}
      />
      {values.placement_key !== NO_PLACEMENT && (
        <>
          <OvTextField
            id={`${id}-position`}
            size="small"
            label={t('videos.fields.order')}
            value={values.position}
            disabled={isDisabled}
            autoFocus={isPositionFocused}
            inputProps={{ inputMode: 'numeric' }}
            error={!!positionError}
            helperText={positionError ?? t('videos.placement.orderHint')}
            onChange={(event) => onChange({ position: event.target.value })}
          />
          <OvVideoHealthGoalsField
            goals={values.health_goals}
            isDisabled={isDisabled}
            onChange={(health_goals) => onChange({ health_goals })}
          />
        </>
      )}
    </Fields>
  );
};

export default OvVideoPlacementFields;

const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;
